import type { TipsContent } from "@/app/components/Tips";

const languages: TipsContent = {
	summary:
		"Including your language skills in your CV can demonstrate your ability to communicate effectively in different contexts and with diverse groups of people.",
	tips: ["Only include languages that you are proficient in and can comfortably use in a professional context."],
};

export default languages;
